import { IBaseUser } from '../../../typings/model/user';
import Cookies from 'js-cookie';
import { updateUin } from '../../../util/aegis';
import { updateReportCommonData } from '../../api/report';
const DEFAULT_UID = '';
const UID_COOKIE_KEY = 'kk-h5-uid';
const LU_UID_COOKIE_KEY = 'lu_uid';

/**
 * 用户信息管理中心
 * - 全局存储和分发相关的用户信息
 */
class UserManager {
  /** 单实例 */
  private static instance: UserManager;
  public static getInstance(): UserManager {
    if (!UserManager.instance) {
      UserManager.instance = new UserManager();
    }

    return UserManager.instance;
  }

  /** 当前的用户id */
  private currentUid = DEFAULT_UID;

  /** 用户信息Map(key: uid, value: IBaseUser) */
  private userMap: Record<string, IBaseUser> = {};

  /**
   * 批量设置用户信息
   * @param userMap 用户信息Map
   */
  public batchSetUser(userMap: Map<string, IBaseUser>): void {
    userMap.forEach((user, userId) => {
      this.userMap[userId] = user;
    });
  }

  /**
   * 批量设置用户信息
   * @param userList 用户信息集合
   */
  public setUserList(userList: IBaseUser[]): void {
    for (const user of userList) {
      this.userMap[user.uid] = user;
    }
  }

  /**
   * 设置用户信息
   * @param userId 用户id
   * @param user 用户信息
   */
  public setUser(userId: string, user: IBaseUser): void {
    this.userMap[userId] = user;
  }

  /**
   * 获取用户信息
   * @param userId 用户id
   * @returns 用户信息
   */
  public getUser(userId: string): IBaseUser | null {
    return this.userMap[userId] || null;
  }

  /**
   * 判断uid是否为当前用户的uid
   * @param uid
   * @returns uid是否为当前用户的uid
   */
  public isCurrentUid(uid: string): boolean {
    return this.currentUid === uid;
  }

  /**
   * 设置当前的uid
   * @param uid
   */
  public setCurrentUid(uid: string): void {
    const path = '/';
    const expires = 1000 * 60 * 60 * 30;
    Cookies.set(UID_COOKIE_KEY, uid, { expires, path });
    updateUin(uid);
    updateReportCommonData({ uid });
    this.currentUid = uid;
  }

  /**
   * 清理当前的uid
   */
  public clearCurrentUid(): void {
    this.currentUid = DEFAULT_UID;
  }

  /**
   * 当前用户是否登录
   */
  public hasCurrentUserLoginIn(): boolean {
    return Boolean(this.currentUid);
  }

  /**
   * 获取当前的uid
   */
  public getCurrentUid(): string {
    return this.currentUid || Cookies.get(UID_COOKIE_KEY) || DEFAULT_UID;
  }

  /**
   * 获取lu-uid
   */
  public getLuUid(): string {
    return Cookies.get(LU_UID_COOKIE_KEY) || DEFAULT_UID;
  }
}

export { UserManager };
